export default __webpack_public_path__ + "static/media/868226268187992094.8fec33bc.png";